var _path, _circle, _circle2, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 110,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.15,
    fill: "#717074",
    d: "M55 2.5C26.005 2.5 2.5 26.005 2.5 55s23.505 52.5 52.5 52.5 52.5-23.505 52.5-52.5S83.995 2.5 55 2.5zm0 96c-24.024 0-43.5-19.476-43.5-43.5S30.976 11.5 55 11.5 98.5 30.976 98.5 55 79.024 98.5 55 98.5z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 0.15,
    fill: "#fff",
    r: 43.5,
    cy: 55,
    cx: 55
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 0.15,
    fill: "#1d428a",
    r: 28.737,
    cy: 55.527,
    cx: 55.251
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.15,
    fill: "#0091da",
    d: "M95.77 54.433l-10.46-3.4c-1.91-13.61-12.79-24.38-26.46-26.1.05-.06.08-.16.05-.26l-3.41-10.46c-.18-.54-.95-.54-1.11 0l-3.41 10.46c-.03.1 0 .21.06.27-5.94.76-11.34 3.24-15.71 6.91l-.09-.06-6.48-3.3c-.36-.18-.74.2-.56.54l3.31 6.51c.01.03.03.05.05.07-3.62 4.3-6.08 9.61-6.89 15.43l-10.43 3.39a.59.59 0 0 0 0 1.13l10.35 3.37c1.64 13.91 12.65 24.99 26.51 26.75l3.29 10.09c.16.56.93.56 1.11 0l3.28-10.08c6.07-.74 11.6-3.28 16.04-7.06l6.17 3.14c.36.18.72-.2.54-.56l-3.14-6.18a30.35 30.35 0 0 0 7.01-16.09l10.38-3.38a.59.59 0 0 0 0-1.13zm-40.78 27.28c-14.57 0-26.41-11.85-26.41-26.41s11.84-26.4 26.41-26.4c14.56 0 26.4 11.84 26.4 26.4s-11.84 26.41-26.4 26.41z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.15,
    fill: "#00c1d5",
    d: "M60.804 60.508L27.371 82.582a.67.67 0 0 1-.922-.928l22.278-33.23 33.245-22.255a.67.67 0 0 1 .928.922L60.804 60.508z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.28ba3620771301a5d17d1259129e08a8.svg";
export { ForwardRef as ReactComponent };